// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const toedscruel: PokeData = {
  "id": 949,
  "name": "toedscruel",
  "height": 19,
  "weight": 580,
  "base_experience": 180,
  "types": [
    PokeType.GROUND,
    PokeType.GRASS
  ],
  "api_moves": [
    "tackle",
    "wrap",
    "supersonic",
    "absorb",
    "mega-drain",
    "growth",
    "poison-powder",
    "stun-spore",
    "screech",
    "spore",
    "mud-slap",
    "giga-drain",
    "mud-shot",
    "seed-bomb",
    "earth-power",
    "power-whip",
    "hex",
    "reflect-type"
  ],
  "moves": [
    "tackle",
    "supersonic",
    "poison-powder",
    "stun-spore",
    "mud-slap",
    "mud-shot",
    "earth-power",
    "power-whip",
    "magnitude",
    "solar-beam",
    "rototiller",
    "branch-poke",
    "bullet-seed"
  ],
  "evolution_chain": {
    "id": 496,
    "item": null,
    "species": [
      {
        "name": "toedscool",
        "order": 1006,
        "types": [
          PokeType.GROUND,
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "toedscruel",
        "order": 1007,
        "types": [
          PokeType.GROUND,
          PokeType.GRASS
        ],
        "evolves_from_species_id": 948,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 130,
    "speed": 150,
    "ability_power": 120
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
